import React, { Component } from 'react';
import PropTypes from 'prop-types';

import PricingTrendsChart from 'ps-components/PricingTrendsChart/PricingTrendsChart';
import LoadingMarketAnalysis from '../LoadingStates/LoadingMarketAnalysis';

import './PricingTrends.scss';

class PricingTrends extends Component {
  static propTypes = {
    pricingYear: PropTypes.number,
    pricingTrends: PropTypes.arrayOf(
      PropTypes.shape({
        year: PropTypes.number,
        count: PropTypes.number
      })
    )
  };

  render() {
    const hasValues =
      this.props.pricingTrends &&
      this.props.pricingTrends.length > 0 &&
      this.props.pricingTrends[0].count !== null &&
      this.props.pricingTrends[0].count >= 0;

    if (!hasValues) {
      return (
        <div className="home__pricingtrends-indicator">
          <LoadingMarketAnalysis />
        </div>
      );
    }
    return (
      <div className="home__pricingtrends-container">
        <div className="home__pricingtrends-title">Pricing Trends</div>
        <div className="home__pricingtrends-subtitle">Number of Jobs Priced and Slotted Over 3 Years</div>
        <div className="home__pricingtrends-chart">
          <PricingTrendsChart pricingTrends={this.props.pricingTrends} />
        </div>
      </div>
    );
  }
}

export default PricingTrends;
